var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgHarmony(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#053b5c;}"))), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "tl_category_harmony_icon") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M31.06,64.77c0-23,24.77-18.47,24.77-30.71,0-5.1-2.12-10.47-12.19-10.47A31.36,31.36,0,0,0,12.5,54.73a31,31,0,0,0,31,30.83A23.24,23.24,0,0,1,31.06,64.77M56.48,14.44a23.24,23.24,0,0,1,12.46,20.8c0,23-24.77,18.46-24.77,30.7,0,5.1,2.12,10.47,12.19,10.47A31.36,31.36,0,0,0,87.5,45.27a31,31,0,0,0-31-30.83"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHarmony);
export default __webpack_public_path__ + "static/media/harmony.330a1e0651073163d890eaa52038d934.svg";
export { ForwardRef as ReactComponent };